import { useEvaluatorFeedbackKeys } from '@/Pages/Playground/utils/use-evaluator-feedback-keys';
import { FeedbackChip } from '@/components/FeedbackChips';
import { Skeleton } from '@/components/Skeleton';
import { Tooltip } from '@/design-system';
import { useOrganizationId } from '@/hooks/useSwr';
import { RuleSchema } from '@/types/schema';

import { isCompositeScoreRule } from '../utils/convertFeedbackFormulaToRule';

export const FeedbackKeyCell = ({ row }: { row: RuleSchema }) => {
  const organizationId = useOrganizationId();

  const feedbackKeys = useEvaluatorFeedbackKeys({
    organizationId: organizationId,
    datasetId: row.dataset_id,
    sessionId: row.session_id,
    selectedRuleIds: new Set([row.id]),
  });

  if (isCompositeScoreRule(row)) {
    const originalFormula = row.formula;
    return (
      <div className="flex flex-nowrap gap-2 overflow-x-auto no-scrollbar">
        <div className="flex-shrink-0">
          <FeedbackChip feedback_key={originalFormula.feedback_key} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-nowrap gap-2 overflow-x-auto no-scrollbar">
      {feedbackKeys.isLoading ? (
        <div className="flex items-center">
          <Skeleton className="h-4 w-20" />
        </div>
      ) : feedbackKeys.evaluatorFeedbackKeys.length ? (
        feedbackKeys.evaluatorFeedbackKeys.map((key) => (
          <div key={key} className="flex-shrink-0">
            <FeedbackChip feedback_key={key} />
          </div>
        ))
      ) : (
        <Tooltip title="Unable to infer feedback keys for this evaluator. Don't worry - your evaluator will still work as expected.">
          <div className="text-xs text-tertiary">Unable to infer</div>
        </Tooltip>
      )}
    </div>
  );
};
